// 用户角色
export type Role = 'super_admin' | 'admin' | 'agent' | 'client';

// 租户/用户信息
export interface UserInfo {
  id: string;
  name: string;
  username: string;
  role: Role;
  tenantId: string;       // 租户ID，super_admin 为 'root'
  tenantName: string;
  avatar?: string;
  permissions: string[];  // 权限列表
  token: string;
}

// 菜单权限映射
export const ROLE_MENUS: Record<Role, string[]> = {
  super_admin: ['dashboard','card','esim','package','user','commission','location','alert','sms','workorder','report','api','settings'],
  admin:       ['dashboard','card','esim','package','user','commission','location','alert','sms','workorder','report','api'],
  agent:       ['dashboard','card','package','location','alert','workorder','report'],
  client:      ['dashboard','card','location','alert','workorder'],
};

// SIM卡
export interface SimCard {
  iccid: string;
  msisdn: string;
  imsi: string;
  operator: string;
  status: string;
  package: string;
  usedMB: number;
  totalMB: number;
  expireDate: string;
  activateDate: string;
  client: string;
  tags: string[];
}

// 跃创API响应
export interface YueAPIResponse<T> {
  code: number;
  message: string;
  data: T;
}
